import { z } from 'zod';

export const DataSyncChildRecordTypeSchema = z.enum(['Comment','Attachment','Violation','Action','Address','Vehicle']);

export type DataSyncChildRecordTypeType = `${z.infer<typeof DataSyncChildRecordTypeSchema>}`

export default DataSyncChildRecordTypeSchema;
